module.exports = __webpack_public_path__ + "img/juniper.faa22784.svg";